import { clientState } from './clientState';
// UI restrictions supplement backend authorization.
const auditedRoutes = {
  '/item': ['rcs-admin', 'rcs-store'],
  '/billing': ['rcs-admin', 'department', 'pay-cre', 'rcs-store'],
  '/jpc-user': ['rcs-admin'],
  '/indent-request': ['rcs-admin', 'department', 'dep-rep', 'pay-cre', 'rcs-store'],
};
export const canOpenRoute = pathname => {
  const path = pathname.toLowerCase().replace(/\/+$/, '');
  try {
    const role = JSON.parse(clientState.getItem('user') || '{}').role?.toLowerCase();
    const within = root => path === root || path.startsWith(root + '/');
    if (['indent', 'ind-ris'].includes(role) && (within('/reports') || within('/stores'))) return false;
    if (['ind-apr', 'st-ind-apr'].includes(role) && within('/grn')) return false;
    const roles = auditedRoutes[path];
    return !roles || roles.includes(role);
  } catch { return false; }
};
